import { DateTime } from 'luxon'

import { DATE_HH_MM, DATE_TIMEZONE } from '../../../../../shared/constants'
import { ManagerWorkingHoursType } from '../../types'

const getAdaptedTime = ({ locale, time, timezone }: { locale: string; time: string; timezone: string }) => {
  const [hour, minute] = time.split(':').map(Number)

  return DateTime.fromObject({ hour, minute }, { locale, zone: timezone }).toLocal()
}

export const getWorkingHours = ({ locale, workingHours }: { locale: string; workingHours: ManagerWorkingHoursType }) => {
  const { from, timezone, to } = workingHours

  const adaptedFromTime = getAdaptedTime({ locale, time: from, timezone })
  const adaptedToTime = getAdaptedTime({ locale, time: to, timezone })

  return `${adaptedFromTime.toFormat(DATE_HH_MM)} – ${adaptedToTime.toFormat(DATE_HH_MM)} ${adaptedFromTime.toFormat(DATE_TIMEZONE)}`
}
